import { render, staticRenderFns } from "./namespace-tree.vue?vue&type=template&id=86a8bc8a&scoped=true"
import script from "./namespace-tree.vue?vue&type=script&lang=js"
export * from "./namespace-tree.vue?vue&type=script&lang=js"
import style0 from "./namespace-tree.vue?vue&type=style&index=0&id=86a8bc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a8bc8a",
  null
  
)

export default component.exports